import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface FaqDialogData {
 area: string;
 issue: string;
}

@Component({
    selector: 'faq-modal',
    templateUrl: './faq-modal.component.html',
    styleUrls: ['./faq-modal.component.css'],
    standalone: false
})
export class FaqModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: FaqDialogData) { 
    
  }

  ngOnInit() {
  }

}
